import React from "react";
import { CARD_BORDER_GRADIENT } from "../constants/theme";

export default function GradientSection({ children, className = "mb-16" }) {
    return (
        <div className={`${className} rounded-2xl shadow-lg p-1`} style={{ background: CARD_BORDER_GRADIENT }}>
            <div className="rounded-2xl bg-gray-900/90 p-8">{children}</div>
        </div>
    );
}
